import { Image, ScrollView, Square, View, XStack, YStack } from "tamagui";
import { getLanguage } from "../../core/utils";
import { Body } from "../../ui/Body";
import { Label } from "../../ui/Label";
import { Subtext } from "../../ui/Subtext";
import type { HotelRawData } from "./types-hotel";

const BOX_SIZE = 220;

const currencyFormatters: { [key: string]: Intl.NumberFormat } = {};

const getCurrencyFormatter = (currency = "USD") => {
  if (!currencyFormatters[currency]) {
    currencyFormatters[currency] = new Intl.NumberFormat(getLanguage(), {
      style: "currency",
      currency: currency,
    });
  }

  return currencyFormatters[currency];
};

export const HotelsTipsBar = ({
  daysCount,
  tips,
  onSelect,
}: {
  daysCount: number;
  tips: HotelRawData[];
  onSelect: (tip: HotelRawData) => void;
}) => {
  const formatter = new Intl.NumberFormat(getLanguage(), {});

  const content = [];

  for (let i = 0; i < tips.length; i++) {
    const currentTip = tips[i];

    content.push(
      <View
        cursor="pointer"
        key={currentTip.id}
        onPress={() => {
          onSelect(currentTip);
        }}
        width={BOX_SIZE}
        backgroundColor={"$backgroundBlock"}
        minWidth={BOX_SIZE}
        minHeight={BOX_SIZE}
      >
        <YStack flex={1}>
          <View>
            <Image
              height={BOX_SIZE}
              source={{ uri: currentTip.max_1440_photo_url }}
            />

            {!!currentTip.urgency_message && (
              <Subtext
                color={"$color"}
                numberOfLines={1}
                style={{
                  position: "absolute",
                  bottom: 4,
                  left: 4,
                  right: 4,
                  backgroundColor: "rgba(255,255,255,0.9)",
                  padding: 4,
                }}
              >
                {currentTip.urgency_message}
              </Subtext>
            )}
          </View>

          <YStack
            gap="$small"
            paddingVertical="$medium"
            paddingHorizontal="$medium"
            justifyContent="space-between"
            flex={1}
          >
            <Label numberOfLines={1}>{currentTip.hotel_name}</Label>

            <YStack gap="$medium" width={"100%"}>
              <XStack
                gap="$small"
                width={"100%"}
                alignItems="center"
                justifyContent="space-between"
              >
                <YStack justifyContent="center">
                  <Body>{currentTip.review_score_word}</Body>
                  <Subtext>
                    {formatter.format(currentTip.review_nr ?? 0)} reviews
                  </Subtext>
                </YStack>

                <Square
                  minHeight={34}
                  minWidth={34}
                  backgroundColor={"#003b95"}
                  aspectRatio={1}
                  borderRadius={4}
                  borderBottomLeftRadius={0}
                >
                  <Label color="white">{currentTip.review_score}</Label>
                </Square>
              </XStack>
              <Label>
                {getCurrencyFormatter(currentTip.currency_code).format(
                  currentTip.min_total_price,
                )}
              </Label>
            </YStack>
          </YStack>
        </YStack>
      </View>,
    );
  }

  return (
    <YStack gap="$small">
      <XStack
        flex={1}
        marginHorizontal="$medium"
        alignItems="center"
        justifyContent="space-between"
      >
        <Subtext fontSize={10} fontWeight={"600"} letterSpacing={1.1}>
          OUR TIPS - Price for{" "}
          {daysCount === 1 ? "1 night" : `${daysCount} nights`}, 2 adults
        </Subtext>
        <Image
          width={80}
          height={14}
          source={require("../../../assets/external/Booking_Com_Logotype_Aug2020_Blue.png")}
        />
      </XStack>
      <ScrollView className="scrollbar-hide" horizontal>
        <XStack gap="$medium" width={"100%"} marginHorizontal="$medium">
          {content}
        </XStack>
      </ScrollView>
    </YStack>
  );
};
